import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatchContext } from '../../hooks';
import BottomAxis from './BottomAxis';
import BottomLogAxis from './BottomLogAxis';
import LeftAxis from './LeftAxis';
import LeftLogAxis from './LeftLogAxis';
import RightAxis from './RightAxis';
import RightLogAxis from './RightLogAxis';
import TopAxis from './TopAxis';
import TopLogAxis from './TopLogAxis';
export default function Axis({ id, position, min, max, paddingStart, paddingEnd, flip = false, scale = 'linear', 
// children props
label, fontSize = 16, labelSpace = 24, displayGridLines, labelStyle, hidden = false, tickStyle = {}, hiddenTicks, tickEmbedded, tickLength = 6, hiddenSecondaryTicks, }) {
    const { dispatch } = useDispatchContext();
    const xY = ['top', 'bottom'].includes(position) ? 'x' : 'y';
    useEffect(() => {
        const minPadding = paddingStart || 0;
        const maxPadding = paddingEnd || 0;
        if (minPadding < 0 || minPadding > 1) {
            throw new Error(`Padding ${position} (${minPadding}) is not between 0 and 1`);
        }
        if (maxPadding < 0 || maxPadding > 1) {
            throw new Error(`Padding ${position} (${maxPadding}) is not between 0 and 1`);
        }
        dispatch({
            type: 'newAxis',
            value: {
                id: id || xY,
                position,
                min,
                max,
                paddingStart: minPadding,
                paddingEnd: maxPadding,
                flip,
                scale,
            },
        });
        return () => dispatch({ type: 'removeAxis', value: { id: id || xY } });
    }, [
        dispatch,
        xY,
        id,
        position,
        min,
        max,
        flip,
        paddingStart,
        paddingEnd,
        scale,
    ]);
    const childProps = {
        id: id || xY,
        displayGridLines,
        hidden,
        label,
        labelSpace,
        labelStyle,
        fontSize,
        tickStyle,
        hiddenTicks,
        tickEmbedded,
        tickLength,
        hiddenSecondaryTicks,
    };
    switch (`${position}-${scale}`) {
        case 'top-log':
            return _jsx(TopLogAxis, Object.assign({}, childProps), void 0);
        case 'top-linear':
            return _jsx(TopAxis, Object.assign({}, childProps), void 0);
        case 'bottom-log':
            return _jsx(BottomLogAxis, Object.assign({}, childProps), void 0);
        case 'bottom-linear':
            return _jsx(BottomAxis, Object.assign({}, childProps), void 0);
        case 'left-log':
            return _jsx(LeftLogAxis, Object.assign({}, childProps), void 0);
        case 'left-linear':
            return _jsx(LeftAxis, Object.assign({}, childProps), void 0);
        case 'right-log':
            return _jsx(RightLogAxis, Object.assign({}, childProps), void 0);
        case 'right-linear':
            return _jsx(RightAxis, Object.assign({}, childProps), void 0);
        default:
            return null;
    }
}
//# sourceMappingURL=index.js.map